export const firebaseConfig = {
    apiKey: "AIzaSyCUqtKBFMw8IpW_--wGIgQ9R_W3iHGemZ0",
    authDomain: "food-fetcher-foobar.firebaseapp.com",
    projectId: "food-fetcher-foobar",
    storageBucket: "food-fetcher-foobar.appspot.com",
    messagingSenderId: "1015799361586",
    appId: "1:1015799361586:web:6302e807104d0549c50c2b",
    measurementId: "G-JBP0XXDHKV"
}
